<chart class="chart-container" *ngIf="!noDataAvailable"
  [options]="options">
</chart>
<div *ngIf="titleTooltip" class="tooltip-title-wrapper">
  <achoo-icon-tooltip [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
</div>
<div class="chart-container" *ngIf="noDataAvailable">
  <achoo-pie-chart-placholder [title]="chartTitle"
                              [list]="listLegendPlaceholder"
                              [messageTitle]="fallbackTitle"
                              [messageContent]="fallbackMsg">
  </achoo-pie-chart-placholder>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-pie-chart/achoo-pie-chart.component.html